// 基础信息
<template>
  <div>
    <Logo></Logo>
    <!-- <Header/> -->
    <div><img :src="image" class="bg"></div>
    <!-- 13个部分 每一部分分头和身体 -->
    <div>
		<div v-for="(list,i) in lists">
			<div class="fix">
                <div class="title">{{list.title}}：</div>
                <div class="text">{{list.text}}</div>
            </div>
		</div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Basic',
  created () {
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
  },
  data () {
    return {
      image: '',
      lists: [
        { id: 1, title: '公司名称', text: '北京清大天达光电科技股份有限公司' },
        { id: 2, title: '股票简称', text: '清大天达' },
        { id: 3, title: '股票代码', text: '833665' },
        { id: 4, title: '注册地址', text: '北京市平谷区马坊镇金马北街61号院2号楼1至2层101' },
        // { id: 5, title: '法定代表人', text: '焦烨华' },
        // { id: 6, title: '公司董秘', text: '段杰' },
        // { id: 7, title: '实际控制人', text: '林长森' },
        // { id: 8, title: '总股本', text: '4114.29万' },
        // { id: 9, title: '行业分类', text: 'C3562电子工业专用设备制造' },
        // { id: 10, title: '挂牌日期', text: '2015-10-28' },
        // { id: 11, title: '主办券商', text: '财达证券' },
        { id: 12, title: '联系电话', text: '010-87397649' },
        { id: 13, title: '传　　真', text: '010-87396145' },
        { id: 14, title: '电子邮箱', text: 'dongmi@bjtstd.com.cn' },

      ]
    }
  },
  components: {
    // Header,
    Tabbar,
    Logo,
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.fix {
  display: flex;
  width: 43.875rem;
  margin-right: auto;
  margin-left: auto;
}
.title {
  color: #666666;
  font-size: 1.75rem;
  margin-top: 1.5rem;
  /* height: 2.4375rem; */
  line-height: 2.4rem;
  word-break: keep-all;
}
.text {
  color: #333333;
  margin-left: 0.5rem;
  margin-top: 1.5rem;
  font-size: 1.75rem;
  max-width: 33.5rem;
  /* height: 2.4375rem; */
  /* padding-top: 2px; */
  line-height: 2.4rem;
  vertical-align:bottom;
  border: 1px transparent red;
  padding-top:1px;
}
</style>